import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useState } from 'react';
import shallow from 'zustand/shallow';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import useStore from './../store';
import FeederLegendContent from './FeederLegendContent';
/**
 * Layout sets up the basic layout for the explorer.
 * @param Object children Child elements
 * @param Object props    Props passed from parent
 */

var FeederMobileModal = function FeederMobileModal(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var activeFeeder = useStore(function (state) {
    return state.activeFeeder;
  });
  var feederLocked = useStore(function (state) {
    return state.feederLocked;
  });
  var activeView = useStore(function (state) {
    return state.activeView;
  });
  var breakpoint = useStore(function (state) {
    return state.breakpoint;
  }); // Track and update intro modal display

  var _useState = useState(!!activeFeeder && !!feederLocked && activeView === 'feeder' && (breakpoint == 'xs' || breakpoint == 'sm' || breakpoint == 'md')),
      showFeederModal = _useState[0],
      setShowFeederModal = _useState[1];

  var toggleFeederModal = function toggleFeederModal() {
    return setShowFeederModal(!showFeederModal);
  };

  useEffect(function () {
    if (!!activeFeeder && !!feederLocked && activeView === 'feeder' && (breakpoint == 'xs' || breakpoint == 'sm' || breakpoint == 'md')) {
      setShowFeederModal(true);
    } else {
      setShowFeederModal(false);
    }
  }, [activeFeeder, feederLocked]);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: showFeederModal,
    toggle: toggleFeederModal,
    className: 'feeder-modal',
    backdrop: true,
    keyboard: true,
    autoFocus: true,
    centered: true
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: toggleFeederModal
  }), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(FeederLegendContent, null)));
};

export default FeederMobileModal;